import {SubmitHandler, FieldValues, useFormContext} from 'react-hook-form';

import './CSS/ValidationForm.css';

interface FieldConfig {
    name: string;
    label: string;
    type: string;
    rules: any;
    defaultValue?: any;
}

/**
 * バリデーション処理が有効なフォームの設定オブジェクトです。
 */
type ValidatoinFormConfig = {
    /**
     * フォームのフィールドを指定します。
     * ここでバリデーションルールの設定も指定します。
     */
    fields: Array<FieldConfig>;

    /**
     * 送信ボタンを有効にするかの指定を行います。
     * trueで有効、falseで無効です。
     */
    enableSubmitButton: boolean;

    /**
     * 送信ボタンのテキストを指定します。
     */
    submitButtonText: string;

    /**
     * キャンセルボタンを有効にするかの指定を行います。
     * trueで有効、falseで無効です。
     */
    enableCancelButton: boolean;

    /**
     * キャンセルボタンのテキストを指定します。
     */
    cancelButtonText: string;

    /**
     * 送信処理のコールバックを指定します。
     */
    submitCallback: SubmitHandler<FieldValues>;
};

/**
 * バリデーションフォームのプロパティです。
 */
type ValidatoinFormProps = {
    /**
     * フォームの設定を指定します。
     */
    config: ValidatoinFormConfig;
};

/**
 * バリデーションフォームのコンポーネントです。
 * @param props バリデーションフォームのプロパティを指定します。
 * @returns React.FunctionComponent
 */
const ValidatoinForm: React.FC<ValidatoinFormProps> = (props: ValidatoinFormProps) => {
    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useFormContext();

    return (
        <form onSubmit={handleSubmit(props.config.submitCallback)} className='validation-form' noValidate>
            {props.config.fields.map((value, index) => {
                if (value.name !== undefined) {
                    return (
                        <div className='input-group' key={index}>
                            <label>{value.label}</label>
                            {value.defaultValue === undefined ? (
                                <input type={value.type} {...register(value.name, value.rules)} className={errors[value.name] ? 'error' : ''}></input>
                            ) : (
                                <input
                                    type={value.type}
                                    {...register(value.name, value.rules)}
                                    ref={value.defaultValue}
                                    className={errors[value.name] ? 'error' : ''}
                                ></input>
                            )}

                            {errors[value.name] && <span className='error'>{errors[value.name]?.message?.toString()}</span>}
                        </div>
                    );
                } else {
                    return <></>;
                }
            })}
            <div className='form-control'>
                {props.config.enableSubmitButton && <button type='submit'>{props.config.submitButtonText}</button>}
                {props.config.enableCancelButton && (
                    <button type='button' className='danger'>
                        {props.config.cancelButtonText}
                    </button>
                )}
            </div>
        </form>
    );
};

export default ValidatoinForm;

export type {ValidatoinFormProps, ValidatoinFormConfig, FieldConfig};
